import { useEffect } from "react";
import { useFormikContext } from "formik";

const AutoSelectFirstTab = ({ setActiveTab, tabConfig }) => {
  const { values } = useFormikContext();

  useEffect(() => {
    const visibleTabs = tabConfig.filter(
      (tab) => values.notificationData[tab.key]
    );
    if (visibleTabs.length > 0) {
      setActiveTab((prev) =>
        visibleTabs.some((t) => t.id === prev) ? prev : visibleTabs[0].id
      );
    } else setActiveTab("");
  }, [values.notificationData, setActiveTab]);

  return null;
};
export default AutoSelectFirstTab;
